import { gql } from 'graphql-request'

export const VERIFY_NEWS_SLUG = gql`
  query Query($slug: String!) {
    verifyNewsSlug(slug: $slug)
  }
`
